(function() {
  var AngularService,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AngularService = App.loadClass('core::Angular/Service');

  exports.CustomersService = (function(superClass) {
    extend(CustomersService, superClass);

    function CustomersService(http) {
      this.http = http;
      return;
    }

    CustomersService.prototype.getPrograms = function(filters) {
      return this.http.post('backend/portal/customers/get-programs', {
        filters: filters
      }).then(function(response) {
        return response.data.data;
      });
    };

    CustomersService.prototype.getSusCustomers = function() {
      return this.http.get('backend/portal/customers/get-sus-customers').then(function(response) {
        return response.data;
      });
    };

    CustomersService.prototype.generatePDF = function(url, year, crop, program) {
      return this.http.get(url, {
        params: {
          year: year,
          crop: crop,
          program: program
        }
      }).then(function(response) {
        return response.data;
      });
    };

    return CustomersService;

  })(AngularService);

}).call(this);
